<template>
  <span class="journey-item">
    <span
    :class="`journey-tile ${tileClasses}`">
      <span class="new" v-if="journey.new"></span>
      <JourneyProgress v-if="showProgress" :steps="journey.steps"></JourneyProgress>
      <h4 :class="{'has-progress': showProgress}">
        {{journey.title}}<br>
        {{journey.complete ? `(${$t('message.completed')})` : ""}}
      </h4>
      <div class="metadata gray-tile added" v-if="journey.added && !journey.started">
        {{ $t("message.added-to-journey") }}
      </div>
      <div class="metadata gray-tile" v-if="!activeOrComplete && journey.duration">
        <JourneyMetadata :duration="journey.duration"></JourneyMetadata>
      </div>
      <button
      @click="handlePrimary"
      class="link-button"
      v-if="!journey.complete">
        {{linkText}}
        <RightArrow
        :opacity="1"
        fill="white">
        </RightArrow>
      </button>
      <a :href="`?journey=${journey.id}`"
        v-if="journey.added && !journey.started"
        class="link-button link-button--secondary"
        @click="handleSecondary"
        >
        {{ $t('message.journey-details') }}
      </a>
      <div class="description"
        v-html="journey.description">
      </div>
    </span>
  </span>
</template>

<style lang="less" scoped>
  @import "./shared.less";
  .journey-item{
    max-width: 725px;
    width: 33.33333%;
    padding: 15px;
    display: flex;
    @media screen and (max-width: 1080px){
      width: 50%;
    }
    @media screen and (max-width: 725px){
      width: 100%;
    }
  }
  .journey-tile {
    background: #333;
    border-radius: 6px;
    -webkit-box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    color: white;
    display: block;
    padding: 25px 25px 15px 25px;
    width: 100%;
    .new::v-deep{
      position: absolute;
      top: 4px;
      right: 8px;
    }
    h4 {
      margin: 0 0 30px 0;

      &.has-progress {
        margin-top: 30px;
      }
    }
    .metadata {
      position: relative;
      overflow: auto;

      &.added:after {
        content: "";
        display: block;
        height: 10px;
        width: 10px;
        border-radius: 10px;
        background: #E02323;
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
      }
    }
    .link-button {
      background: rgb(0, 127, 255);
      color: white;
      display: inline-block;
      cursor: pointer;
      margin-bottom: 40px;
      margin-right: 12px;
     -webkit-transition: background 0.2s ease-out;
      transition: background 0.2s ease-out;
      &:hover{
        background: darken(rgb(0, 127, 255), 8%);
      }

      &--secondary {
        background: transparent;
        border: 1px solid white;
      }
    }

    .description {
      line-height: 145%;
      overflow: hidden;

      /deep/ img {
        max-width: 100%;
        height: auto;
      }

  
      /deep/ p {
        margin-top: 0.75em;
        color: inherit;
        
        strong {
          font-weight: bold;
        }

        em {
          font-style: italic;
        }

        a {
          color: inherit;
        }
      }
    }
    &.started {
      background: #007fff;
      .link-button {
        margin-top: 20px;
        background: #0064c8;
      }
    }
    &.complete {
      background: gray;
    }
    .time-to-complete::v-deep {
      font-weight: 600;
    }
  }
  @media all and (max-width: 360px) {
    .journey-tile {
      min-width: 265px;
    }
  }
</style>

<script>
  import {mapActions} from "vuex";
  import JourneyProgress from "@/journeys/JourneyProgress";
  import JourneyMetadata from "@/journeys/JourneyMetadata"
  import RightArrow from "@/common/icons/RightArrow"

  export default {
    components: {JourneyProgress, JourneyMetadata, RightArrow},
    props: {
      journey: {
        type: Object,
        required: true
      },
      showProgress: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {}
    },
    computed: {
      linkText() {
        if (this.journey.started) {
          return `${this.$t('message.continue')} ${this.$t('message.journey')}`;
        } else if (this.journey.added) {
          return `${this.$t('message.start-journey')}`;
        } else {
          return this.$t('message.journey-details');
        }
      },
      tileClasses() {
        const classes = [];
        if (this.journey.started) {
          classes.push("started");
        }
        if (this.journey.complete) {
          classes.push("complete");
        }
        return classes.join(" ");
      },
      activeOrComplete() {
        return this.journey.started || this.journey.complete;
      }
    },
    methods: {
      handlePrimary(event) {
        this.openJourney();
        if (this.journey.added && !this.journey.started) {
          this.startSelectedJourney();
        }
      },
      handleSecondary(event) {
        event.preventDefault();
        this.openJourney();
      },
      openJourney() {
        this.$store.commit("setSelectedJourney", this.journey.id);
        this.$store.commit('markJourneysAsViewed');
        this.$store.commit("setShowJourney", true);
      },
      ...mapActions(["startSelectedJourney"])
    }
  }
</script>
